import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
// import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {Layout, Text} from '@phonectas/unifon-ui-kit';
import DefaultRouteSelect from './components/DefaultRouteSelect';

interface BasicSettingsProps {
    value: string;
    onChange?: (val: string) => void;
}

const BasicSettings: React.FC<BasicSettingsProps> = ({value, onChange}) => {
	const [t] = useTranslation();
	const handleRouteChange = useCallback(
		(val: string) => {
			if (onChange) {
				onChange(val);
			}
		},
		[onChange]
	);

	return (
		<Layout fullWidth nowrap direction="column">
			<Layout direction="column" gap="xs" alignItems="start">
				<Text variant='h1'>{t('Basic settings')}</Text>
				<Text variant='h3' color="textSecondary">
					{t('User preferences')}:
				</Text>
			</Layout>
			<Layout
				direction="row"
				gap="sm"
				nowrap
				autoOverflow
				alignItems="center"
				fullWidth
			>
				<Layout
					alignItems="start"
					direction="column"
					gap="md"
					nowrap
					style={{width: '250px'}}
				>
					<DefaultRouteSelect
						value={value}
						onChange={handleRouteChange}
						t={t}
					/>
				</Layout>
			</Layout>
		</Layout>
	);
};

export default BasicSettings;